import axios from './_nestAxios'

export const getTransferencia = _id => axios.get(`/transferencias/${_id}`)
export const imprimirTransferencia = _id => axios.get(`/transferencias/${_id}/imprimir`, { responseType: 'blob' })

export const imprimirRecepcionxId = _id =>
  axios.get(`transferencias/${_id}/imprimirRecepcion`, { responseType: 'blob' })

export const descargarReporteEstandar = data =>
  axios.get('transferencias/reporte/estandar', { responseType: 'blob', params: data })

export const nuevaTransferencia = data => axios.post('/transferencias', data)

export const confirmarRecepcion = (id, payload) => {
  return axios.put(`/transferencias/${id}/confirmar-recepcion`, payload)
}

export const eliminarTransferencia = _id => axios.delete(`/transferencias/${_id}`)
